@let list = anchorList();
@let paragraphs = directoryParagraphs();

@if (list?.length) {
    <div class="grid grid-cols-12 md:gap-8 gap-y-10">
        <div
            class="col-span-12"
            [class.md:col-span-4]="paragraphs?.length">
            <h4>{{ 'app.directory.anchorListTitle' | transloco }}</h4>

            <ul class="mb-0 flex flex-col gap-4">
                @for (item of limitAnchorListItems(list); track item.index) {
                    <li>
                        <big-ui-button
                            (click)="scrollToParagraph(item.index)"
                            [buttonStyle]="'flex text-left tertiary icon relative text-primary-500 dark:text-primary-50 font-sans leading-normal'">
                            <big-icon
                                [icon]="iconArrow"
                                [size]="'w-4'"
                                class="m-1.25 shrink-0 fill-current self-start" />
                            {{ item.content }}
                        </big-ui-button>
                    </li>
                }
                @if (list.length > maxItemsToShow && !anchorListIsExpanded()) {
                    <li class="mt-4">
                        <big-ui-button
                            (click)="anchorListIsExpanded.set(true)"
                            [buttonStyle]="'flex text-left tertiary icon relative text-primary-500 dark:text-primary-50'">
                            <span class="mr-2">{{ 'app.directory.loadMore' | transloco }}</span>
                            <big-icon
                                [icon]="iconPlus"
                                [size]="'w-5'"
                                class="fill-current" />
                        </big-ui-button>
                    </li>
                }
            </ul>
        </div>

        @if (paragraphs?.length) {
            <div class="col-span-12 md:col-span-8">
                <big-paragraphs-holder
                    [data]="paragraphs"
                    [isEmbedded]="true"
                    class="[&_>_big-paragraph-text:has(+big-paragraph-text)]:text-primary-500 dark:[&_>_big-paragraph-text:has(+big-paragraph-text)]:text-primary-50" />
            </div>
        }
    </div>
}
